import chance from 'chance'
import modalProps from '../modalProps'
import { getPlannerPeriodSubcontractors } from '../../../../../HttpRequests/planner'
import { setSubcontractors } from '../State/subcontractors'
import { setJobs } from '../State/jobs'
import { setPlannerCell } from '../State/plannerCell'
import handleException from '../../../../../Core/Helpers/handleException'

export default () => async (dispatch) => {

  const { period, _jobs, _plannerCell, _preselectedSubcontractorId } = modalProps()

  console.log('Initialize modal - preselectedSubcontractorId:', _preselectedSubcontractorId)
  console.log('Initialize modal - _jobs:', _jobs)

  if (_plannerCell) {
    dispatch(setPlannerCell(_plannerCell))
  }

  try {

    const response = await getPlannerPeriodSubcontractors({
      params: { date: period.date },
    })

    dispatch(setSubcontractors(response.data))

    console.log('Subcontractors loaded:', response.data.length)

    // If a subcontractor is preselected and no jobs exist, auto-add one
    if (_preselectedSubcontractorId && _jobs.length === 0) {
      console.log('Attempting to find preselected subcontractor:', _preselectedSubcontractorId)
      const preselectedSubcontractor = response.data.find(sub => sub.id === _preselectedSubcontractorId)
      
      console.log('Found preselected subcontractor:', preselectedSubcontractor)
      
      if (preselectedSubcontractor) {
        const newJob = {
          key: chance().guid(),
          id: null,
          subcontractor_id: _preselectedSubcontractorId,
          slot: 'Day',
          quantity: 1,
          price_work: false,
          confirmed: true,
          subcontractor: preselectedSubcontractor,
        }
        console.log('Creating job with preselected subcontractor:', newJob)
        dispatch(setJobs([newJob]))
      } else {
        console.log('Preselected subcontractor not found in response data')
      }
    } else {
      console.log('Not using preselected subcontractor - setting existing jobs')
      // Set existing jobs with keys
      dispatch(setJobs(_jobs.map(job => ({
        key: chance().guid(),
        ...job,
      }))))
    }

  } catch (error) {

    handleException(error)

  }

}
